module.exports = __webpack_public_path__ + "static/media/2.9ba8e445.jpg";